import styled from '@emotion/styled';
import { Accordion, List, Stack, ThemeIcon } from '@mantine/core';

export const DrawerStack = styled(Stack)(({ theme }) => ({
  gap: 0,
  padding: 0,
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '.mantine-Accordion-item': {
    border: 0,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
  },
  '.mantine-Accordion-control': {
    // padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    backgroundColor: theme.colors.gray[0],
    borderRadius: 0,
    minHeight: 'unset',
  },
  '.mantine-Accordion-control:hover': {
    backgroundColor: theme.colors.gray[1],
  },
  '.mantine-Accordion-panel': {
    // padding: `0 ${theme.spacing.sm} ${theme.spacing.xs}`,
  },
  '.mantine-Accordion-label': {
    padding: `0.5em ${theme.spacing.sm} 0.5em`,
  },
  '.mantine-Accordion-content': {
    padding: 0,
  },
}));

// Makes the itemwrapper take up the full width of the sidebar
export const StyledList = styled(List)`
  list-style: none;
  padding: 0 0.5rem;
  margin-top: 0.5rem;
  & > li {
    margin-bottom: 0.25rem;
  }
  & > li > div {
    width: 100%;
  }
`;

export const StyledComponent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
  cursor: 'pointer',
  border: `1px solid transparent`,
  borderRadius: theme.radius.sm,
  transition: 'background-color 150ms ease',

  ':hover': {
    backgroundColor: theme.colors.gray[0],
    borderColor: theme.colors.gray[2],

    '.node-icon': {
      transform: 'scale(1.06)',
      backgroundColor: theme.colors.blue[6],
      color: theme.white,
    },
  },
}));

export const StyledThemeIcon = styled(ThemeIcon)(({ theme }) => ({
  marginTop: 4,
  transition:
    'background-color 150ms ease, color 150ms ease, transform 150ms ease',

  backgroundColor: theme.colors.gray[1],
  color: theme.colors.gray[7],
}));

export const DrawerRoot = styled('div')(({ theme }) => ({
  width: 350,
  borderLeft: `1px solid ${theme.colors.gray[3]}`,
  boxShadow: `-4px 0 6px rgba(0, 0, 0, 0.06)`,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
}));
